import React from "react";
import { Navigate } from "react-router-dom";
import type { RoutesStructure } from "@/types/routestypes";
import {
  PROFILE_BASE_PATH,
  PROFILE_CHILD_PATHS,
} from "@/pages/Profile/profilePaths";
import { AUTH_ROUTE_PATHS } from "@/pages/Auth/authConfig";

const SignUp = React.lazy(() => import("@/pages/Auth/SignUp/SignUp"));
const SignIn = React.lazy(() => import("@/pages/Auth/SignIn/SignIn"));
const ForgotPassword = React.lazy(
  () => import("@/pages/ForgotPassword/ForgotPassword"),
);
const Home = React.lazy(() => import("@/pages/Home/Home"));
const MemberDetails = React.lazy(
  () => import("@/pages/MemberDetails/MemberDetails"),
);
const Dashboard = React.lazy(() => import("@/pages/Dashboard/Dashboard"));
const Chat = React.lazy(() => import("@/pages/Chat/Chat"));
const Event = React.lazy(() => import("@/pages/Events/Event"));
const ProfileLayout = React.lazy(
  () => import("@/pages/Profile/ProfileLayout/ProfileLayout"),
);
const ProfileHome = React.lazy(() => import("@/pages/Profile/Profile/Profile"));
const Language = React.lazy(() => import("@/pages/Profile/Languages/Language"));
const ProfileSubscription = React.lazy(
  () => import("@/pages/Profile/Subscription/Subscription"),
);
const HelpCentre = React.lazy(
  () => import("@/pages/Profile/HelpCentre/HelpCentre"),
);
const EditQuestionnaire = React.lazy(
  () => import("@/pages/Profile/EditQuestionnaire/EditQuestionnaire"),
);
const QuestionnaireManagament = React.lazy(
  () => import("@/pages/Questionnaire-Management/QuestionnaireManagament"),
);
const Onboarding = React.lazy(
  () => import("@/pages/Onboarding/Welcome/Onboarding"),
);
const Introduction = React.lazy(
  () => import("@/pages/Onboarding/Introduction/Introduction"),
);

const PaymentSuccessfull = React.lazy(()=> import("@/pages/PaymentSuccessfull/PaymentSuccessfull"));

const AdminLogin = React.lazy(
  () => import("@/pages/Auth/AdminLogin/AdminLogin"),
);
const Users = React.lazy(() => import("@/pages/Users/Users"));

const routes = {
  routes: {},
  publicRoutes: {
    ADMIN_LOGIN: {
      path: AUTH_ROUTE_PATHS.adminLogin,
      element: <AdminLogin />,
    },
    SIGN_UP: {
      path: AUTH_ROUTE_PATHS.signUp,
      element: <SignUp />,
    },
    SIGN_IN: {
      path: AUTH_ROUTE_PATHS.signIn,
      element: <SignIn />,
    },
    LEGACY_LOGIN: {
      path: AUTH_ROUTE_PATHS.legacyLogin,
      element: <Navigate replace to={AUTH_ROUTE_PATHS.signIn} />,
    },
    RESET_PASSWORD: {
      path: AUTH_ROUTE_PATHS.resetPassword,
      element: <ForgotPassword />,
    },
    FORGOT_PASSWORD: {
      path: AUTH_ROUTE_PATHS.forgotPassword,
      element: <ForgotPassword />,
    },
    WELCOME: {
      path: AUTH_ROUTE_PATHS.welcome,
      element: <Onboarding />,
    },
    QUESTIONS: {
      path: AUTH_ROUTE_PATHS.questions,
      element: <QuestionnaireManagament />,
    },
    INTRODUCTION: {
      path: AUTH_ROUTE_PATHS.introduction,
      element: <Introduction />,
    },
    PAYMENT_SUCCESSFUL: {
      path: AUTH_ROUTE_PATHS.paymentSuccessful,
      element: <PaymentSuccessfull />,
    },
  },
  privateRoutes: {
    USERS_MANAGEMENT: {
      path: "/admin/users-management",
      element: <Users />,
      pageName: "User Management",
    },
    USERS_MANAGEMENT_IMPORT: {
      path: "/admin/users-management/import-user",
      element: <Users openImportByDefault />,
      pageName: "User Management",
    },
    HOME: {
      path: "/home",
      element: <Home />,
      pageName: "Home",
    },
    MEMBER_DETAILS: {
      path: "/members/:userId",
      element: <MemberDetails />,
      pageName: "Member Details",
    },
    DASHBOARD: {
      path: "/dashboard",
      element: <Dashboard />,
      pageName: "Dashboard",
    },
    CHAT: {
      path: "/chat",
      element: <Chat />,
      pageName: "Chat",
    },
    EVENT: {
      path: "/event",
      element: <Event />,
      pageName: "Event",
    },
    PAYMENT_SUCCESSFUL: {
      path: "/payment-successful",
      element: <PaymentSuccessfull />,
      pageName: "Payment Successful",
    },
    PROFILE: {
      path: PROFILE_BASE_PATH,
      element: <ProfileLayout />,
      pageName: "Profile",
      children: {
        HOME: {
          path: PROFILE_CHILD_PATHS.HOME,
          element: <ProfileHome />,
          pageName: "Profile",
        },
        LANGUAGE: {
          path: PROFILE_CHILD_PATHS.LANGUAGE,
          element: <Language />,
          pageName: "Language",
        },
        SUBSCRIPTION: {
          path: PROFILE_CHILD_PATHS.SUBSCRIPTION,
          element: <ProfileSubscription />,
          pageName: "My Subscription",
        },
        HELP_CENTRE: {
          path: PROFILE_CHILD_PATHS.HELP_CENTRE,
          element: <HelpCentre />,
          pageName: "Help Centre & FAQ",
        },
        EDIT_QUESTIONNAIRE: {
          path: PROFILE_CHILD_PATHS.EDIT_QUESTIONNAIRE,
          element: <EditQuestionnaire />,
          pageName: "Edit Questions",
        },
      },
    },
  },
} as const satisfies RoutesStructure;

export default routes;
